import { render, staticRenderFns } from "./kv-select.vue?vue&type=template&id=0ecfbe3a"
import script from "./kv-select.vue?vue&type=script&lang=js"
export * from "./kv-select.vue?vue&type=script&lang=js"
import style0 from "./kv-select.vue?vue&type=style&index=0&id=0ecfbe3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports